import React, { useImperativeHandle } from 'react';
import { NavLink } from "react-router-dom";
import logoImg from "../assets/images/logo.png";
import { toast } from 'react-toastify';
import customStyles from "../assets/styles/customStyles";
import { useDispatch } from "react-redux";
import crudActions from "../layouts/CRUD/redux/actions";


const RazorPayButton = React.forwardRef((props, ref) => {
    const { orderId, amount, description, name, text, paymentId, handleError } = props;
    const classes = customStyles();
    const dispatch = useDispatch();
    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    useImperativeHandle(ref, () => ({
        payNow() {
            displayRazorpay();
        }
    }));

    async function displayRazorpay() {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            toast.dismiss();
            toast.error('Razorpay SDK failed to load. Are you online?');
            return;
        }

        // const result = await axios.post("http://localhost:5000/payment/orders");

        // if (!result) {
        //     alert("Server error. Are you online?");
        //     return;
        // }

        // const { amount, id: order_id, currency } = result.data;

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
            amount: (amount * 100).toString(),
            currency: 'INR',
            order_id: orderId,
            name: name,
            description: description,
            image: { logoImg },
            // order_id: 152,
            handler: async function (response) {
                const data = {
                    // orderCreationId: order_id,
                    paymentId: response.razorpay_payment_id,
                    //razorpayOrderId: response.razorpay_order_id,
                    signature: response.razorpay_signature,
                    subscriptionPaymentStatus: 'PROCESSING'
                };

                dispatch({
                    type: crudActions.EDIT_DETAILS_START,
                    url: "subscriptionPayments",
                    title: "Subscription Payments",
                    details: data,
                    id: paymentId
                });
            },
            prefill: {
                // name: businessDetails?.businessName || businessDetails?.name,
                // email: businessDetails?.email,
                // contact: businessDetails?.mobile,
                name: '',
                email: '',
                contact: '',
            },
            notes: {
                note_key_1: "Subscription"
            },
            theme: {
                color: "#F37254",
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.on('payment.failed', function (response) {
            //alert(response.error.code);
            paymentObject.close();
            handleError(response.error.description);
            // toast.dismiss();
            // toast.error(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata.order_id);
            // alert(response.error.metadata.payment_id);
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "subscriptionPayments",
                title: "Subscription Payments",
                details: { subscriptionPaymentStatus: 'FAILED' },
                id: paymentId
            });
        });
        paymentObject.open();
    }

    return (
        <NavLink ref={ref} to="#" onClick={() => displayRazorpay()}
            className={classes.AddMoreBtn}>{text || 'Pay Now'}</NavLink>
    )
})

export default RazorPayButton;
